import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function durationComparisonValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = control.value;

    return isValid ? null : { durationComparison: true };
  };
}
